import React, { useRef, VFC } from 'react';
// tempexp_14269-start
import { useSelector } from 'react-redux';
import { getFeatureFreezeAutoRenewal } from 'reactApp/modules/features/features.selectors';
// tempexp_14269-end
import { IPropsWithPopup } from 'reactApp/modules/popup/popup.helpers';
import { Button } from 'reactApp/ui/Button/Button';
import { MobileDialog } from 'reactApp/ui/Mobile/MobileDialog/MobileDialog';
import { formatDefaultDate } from 'reactApp/utils/formatDate';

import styles from './CancelAutoRenewalModal.css';
import { DialogProps } from './CancelAutoRenewalModal.types';
import { useHandlers } from './hooks/useHandlers';
import { useSendAnalyticAfterOpen } from './hooks/useSendAnalyticsAfterOpen';
import { PrivilegeList } from './PrivilegeList/PrivilegeList';

type Props = IPropsWithPopup<DialogProps>;

export const CancelAutoRenewalModal: VFC<Props> = ({ currentSpace, expires, id, dwhData, onClose }) => {
    const scrollRef = useRef<HTMLDivElement>(null);
    // tempexp_14269-next-line
    const freezeAutoRenewalEnabled = Boolean(useSelector(getFeatureFreezeAutoRenewal));

    useSendAnalyticAfterOpen(dwhData, freezeAutoRenewalEnabled);

    const { handleCloseSubscription, handleGoToAllSubscriptions, handleFreezeRenewalClick } = useHandlers(dwhData, onClose);

    return (
        <MobileDialog
            id="mobile-cancel-auto-renewal-modal"
            onClose={onClose}
            closeOnDimmerClick
            mod="confirm"
            topmost
            title={
                <span className={styles.title}>
                    Отключить
                    <br />
                    автопродление?
                </span>
            }
            scrollRef={scrollRef}
            footer={
                <div className={styles.buttonContainer}>
                    {/* tempexp_14269-start */}
                    {freezeAutoRenewalEnabled && (
                        <Button primary size="medium" fluid className={styles.button} onClick={handleFreezeRenewalClick} theme="octavius">
                            Приостановить на 1 месяц
                        </Button>
                    )}
                    {/* tempexp_14269-end */}
                    <Button
                        primary={!freezeAutoRenewalEnabled}
                        secondary={freezeAutoRenewalEnabled}
                        size="medium"
                        fluid
                        className={styles.button}
                        onClick={handleGoToAllSubscriptions}
                        theme="octavius"
                    >
                        Не отключать
                    </Button>
                    <Button
                        secondary
                        size="medium"
                        fluid
                        className={styles.button}
                        onClick={() => handleCloseSubscription(id)}
                        theme="octavius"
                    >
                        Отключить автопродление
                    </Button>
                </div>
            }
        >
            {expires && <span className={styles.subtitle}>С {formatDefaultDate(expires)} вы потеряете:</span>}
            <PrivilegeList ref={scrollRef} currentSpace={currentSpace} />
        </MobileDialog>
    );
};
